import { request } from '@/shared/api/request'
import { camelize } from '@/shared/lib/camelize'

const ANNOUNCEMENTS = '/api/eleva/announcements'

/**
 * A message from the Eleva team for one calendar day (GET announcements/today),
 * already in the language the admins picked for the caller's country.
 */
export interface Announcement {
  id: string
  /** The text to show, line breaks included. */
  message: string
  /** The day it belongs to (yyyy-MM-dd). */
  date: string
}

export const announcementsApi = {
  /**
   * The announcements of `date` (the device's local calendar day, yyyy-MM-dd)
   * that target the caller's profile country and that they have not seen yet,
   * oldest first. A day more than one away from the server's own comes back
   * empty, and so does an account without a country.
   */
  async today(date: string): Promise<Announcement[]> {
    const data = await request<unknown>({ url: `${ANNOUNCEMENTS}/today`, params: { date } })
    const response = camelize<{ data?: Partial<Announcement>[] | null }>(data)
    return (response.data ?? []).flatMap((item) =>
      item.id && item.message?.trim()
        ? [{ id: item.id, message: item.message, date: item.date ?? date }]
        : [],
    )
  },

  /** Records that the popup was shown (idempotent server side). */
  async markSeen(id: string): Promise<void> {
    await request({ method: 'POST', url: `${ANNOUNCEMENTS}/${encodeURIComponent(id)}/seen` })
  },
}
